/* [BD Feat] Js for the GZallery Slider of the Custom Newsletter section */
(function () {
  function initGallerySlider(section) {
    var carousel = section.querySelector('.gallary-wrapper');

    if (!carousel || carousel.flickityInstance) return;

    var flickityInstance = new Flickity(carousel, {
      cellAlign: 'center',
      contain: true,
      wrapAround: true,
      groupCells: 1,
      pageDots: false,
      prevNextButtons: false,
    });
    carousel.flickityInstance = flickityInstance;
  }

  function destroyGallerySlider(section) {
    var carousel = section.querySelector('.gallary-wrapper');
    if (carousel && carousel.flickityInstance) {
      carousel.flickityInstance.destroy();
      carousel.flickityInstance = null;
    }
  }

  function setupGallerySliders() {
    document.querySelectorAll('.gallary-section').forEach(function (section) {
      var carousel = section.querySelector('.gallary-wrapper');
      if (!carousel) return;

      if (!carousel.flickityInstance) {
        initGallerySlider(section);
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    setupGallerySliders();

    // Shopify section load
    document.addEventListener('shopify:section:load', function (event) {
      const section = document.querySelector('.gallary-section[data-section-id="' + event.detail.sectionId + '"]');
      if (section) {
        setTimeout(() => initGallerySlider(section), 500);
      }
    });

    // Shopify section unload
    document.addEventListener('shopify:section:unload', function (event) {
      const section = document.querySelector('.gallary-section[data-section-id="' + event.detail.sectionId + '"]');
      if (section) {
        destroyGallerySlider(section);
      }
    });

    // Shopify theme settings update
    document.addEventListener('shopify:theme-settings:updated', setupGallerySliders);
  });
})();
 